import React from "react";
import WeatherDisplay from "./components/WeatherDisplay";

function App() {
  return (
    <div className="app">
      <WeatherDisplay />
    </div>
  );
}

export default App;
